import { Menu } from "lucide-react";
import { PropsWithChildren, ReactNode, useState } from "react";
import { Sheet, SheetContent, SheetTrigger } from "../sheet/sheet";
import { Logo } from "../logo/logo";
import { DialogProps } from "@radix-ui/react-dialog";

export interface IMainLayoutProps
  extends PropsWithChildren<Pick<DialogProps, "open" | "onOpenChange">> {
  sidebarSlot: ReactNode;
  navigationSlot: ReactNode;
  headerSlot: ReactNode;
  navigationOverlaySlot?: ReactNode;
}

export function MainLayout({
  sidebarSlot,
  navigationSlot,
  headerSlot,
  navigationOverlaySlot,
  children,
  open,
  onOpenChange,
}: IMainLayoutProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  return (
    <div className="flex flex-col h-full">
      <header className="relative flex bg-header text-header-foreground pl-4 pr-1 py-1 gap-4 items-center min-h-14 flex-shrink-0">
        <Sheet open={open} onOpenChange={onOpenChange}>
          <SheetTrigger>
            <Menu className="h5 w-5" />
          </SheetTrigger>
          <SheetContent
            side="left"
            container={container}
            position="absolute"
            showClose={false}
            className="bg-header text-header-foreground w-56 pt-4 px-2 pb-2"
            overlay={navigationOverlaySlot}
          >
            {navigationSlot}
          </SheetContent>
        </Sheet>
        <div className="flex-shrink-0">
          <Logo />
        </div>
        <div className="w-[100%] overflow-auto no-scrollbar">{headerSlot}</div>
      </header>
      <main
        ref={setContainer}
        className="relative flex-grow flex overflow-hidden"
      >
        <div className="flex-grow overflow-auto">{children}</div>
        <div className="w-20 border-l bg-card min-w-20">{sidebarSlot}</div>
      </main>
    </div>
  );
}
